import Service from "./Service"

class VehicleService extends Service {

    findById = (id) => this.get(`/vehicles/${id}`)

    getInvoices = (id, queryParams) => this.getWithParams(`/vehicles/${id}/invoices`, queryParams)

    search = () => this.get("/vehicles")

    getSelectors = () => this.get("/vehicles/selectors")

    createVehicle = (requestBody) => this.post("/vehicles", requestBody)

    deleteVehicle = (id) => this.del(`/vehicles/${id}`)

    deleteVehicleFile = (id, fileId) => this.del(`/vehicles/${id}/files/${fileId}`)
}

const vehicleService = new VehicleService()
export default vehicleService